import request from '@/utils/request'

// register
export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data: data,
    vconfig:{
      noBaseApi:true
    }
  })
}

// login
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data,
    vconfig:{
      noBaseApi:true,
      noErr:true,
    }
  })
}

// get login user info
export function getInfo() {
  return request({
    url: '/userInfo',
    method: 'get'
  })
}


// refresh token
export function checkStatus(param) {
  return request({
    url: '/checkStatus',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
      noErr:true,
    }
  })
}

// producer Count
export function producerCount(param) {
  return request({
    url: '/bcinfo/producerCount',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// TATCount Count
export function TATCount(param) {
  return request({
    url: '/bcinfo/TATCount',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// USPCount Count
export function USPCount(param) {
  return request({
    url: '/bcinfo/USPCount',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// peer count
export function peerCnt(param) {
  return request({
    url: '/bcinfo/peerCnt',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// peer count
export function saveContact(param) {
  return request({
    url: '/hp/saveContact',
    method: 'post',
    data:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// peer count
export function getContractJson(param) {
  return request({
    url: '/js/contract.dic.json',
    method: 'get',
    vconfig:{
      noBaseApi:true,
      noErr:true
    }
  })
}
